import { css } from '@emotion/css';

export const columnsHostStyles = css({
  display: 'block',
  margin: '8px 0',
});

/**
 * Gap between columns. It has to stay wider than the drag handle so the handle
 * of a block in the next column does not land on the resize grip: the handle
 * occupies the last ~18px of the gap, the grip sits near its start.
 */
export const COLUMNS_GAP = 40;

/** Distance from the preceding column's right edge to the grip's centre. */
export const COLUMN_RESIZE_HANDLE_OFFSET = 10;
export const COLUMN_RESIZE_HANDLE_WIDTH = 12;

export const columnsContainerStyles = css({
  display: 'flex',
  gap: `${COLUMNS_GAP}px`,
  alignItems: 'flex-start',
  width: '100%',
  position: 'relative',
});

export const columnHostStyles = css({
  display: 'block',
  flex: '1 1 0',
  minWidth: 0,
});

export const columnContainerStyles = css({
  minHeight: '24px',
  width: '100%',
});

/**
 * Resize grip sitting in the gap between two columns. It is wider than the
 * visible line so it stays easy to grab.
 */
export const columnResizeHandleStyles = css({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: `${COLUMN_RESIZE_HANDLE_WIDTH}px`,
  transform: 'translateX(-50%)',
  cursor: 'col-resize',
  zIndex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'stretch',
  touchAction: 'none',

  '&::after': {
    content: '""',
    width: '2px',
    borderRadius: '1px',
    background: 'transparent',
    transition: 'background 120ms ease',
  },

  '&:hover::after, &[data-resizing="true"]::after': {
    background: 'var(--affine-primary-color)',
  },
});
